import { buildGroupPath } from '@/utils/groupPath';

// NOTE: member names are intentionally prefixed (activeGroupSlug / groupRoutePath)
// to avoid collisions with pre-existing `groupSlug`/`groupPath` props and data
// that already exist in several consumer components (Dashboard, DashboardItem,
// DotDropdown, ModalComponentPage). Do not rename to the bare forms.
const groupNavigation = {
  computed: {
    activeGroupSlug() {
      return this.$route.params.groupSlug || null;
    },
    // Group-LESS item path, for DB/cache/published slug_path values.
    itemSlugPath() {
      return this.$route.params.parametersOfUrl
        ? `/${this.$route.params.parametersOfUrl}`
        : '/';
    },
  },
  methods: {
    groupRoutePath(path) {
      return buildGroupPath(this.activeGroupSlug, path);
    },
  },
};

export default groupNavigation;
